import { Icon } from "@trustpilot/businessapp-patternlibrary";
import { calendarRangeArrow_16 as rightArrow, arrowRight_16 as arrowRight } from "@trustpilot/icons";
import { Text } from "ilenia";
import React from "react";

import styles from "../../styles/sideNav.module.scss";

//Render primary navigation link and icon
const PrimaryNavLinks = ({ menu }) => (
  <span className={styles.sidebarLinks}>
    {menu.icon && <span className={styles.sidebarLinksIcon}>{menu.icon}</span>}
    <span className={styles.sidebarLinksText}>
      <Text id={`Sidebar.${menu.id}`} /> {menu.data && `(${menu.data})`}
    </span>
    {menu.subMenu && (
      <span className={styles.sidebarLinksIconArrow}>
        <Icon content={rightArrow} />
      </span>
    )}
    {menu.subMenu && (
      <span className={styles.sidebarLinksIconArrowRight}>
        <Icon content={arrowRight} />
      </span>
    )}
  </span>
);

export default PrimaryNavLinks;
